// eslint-disable-next-line import/prefer-default-export
export const formSelects = {
  data() {
    return {
      genders: [
        { sex: "Masculino", code: 1 },
        { sex: "Femenino", code: 2 },
      ],
      maritalStatus: [
        { status: "Soltero", code: 1 },
        { status: "Casado", code: 2 },
        { status: "Divorciado", code: 3 },
        { status: "Viudo", code: 4 },
      ],
      countries: [
        { country: "Chile", code: "CHL" },
        { country: "Afganistán", code: "AFG" },
        { country: "Albania", code: "ALB" },
        { country: "Alemania", code: "DEU" },
        { country: "Andorra", code: "AND" },
        { country: "Angola", code: "AGO" },
        { country: "Anguila", code: "AIA" },
        { country: "Antigua y Barbuda", code: "ATG" },
        { country: "Antártida", code: "ATA" },
        { country: "Arabia Saudita", code: "SAU" },
        { country: "Argelia", code: "DZA" },
        { country: "Argentina", code: "ARG" },
        { country: "Armenia", code: "ARM" },
        { country: "Australia", code: "AUS" },
        { country: "Austria", code: "AUT" },
        { country: "Azerbaiyán", code: "AZE" },
        { country: "Bahamas", code: "BHS" },
        { country: "Bangladés", code: "BGD" },
        { country: "Barbados", code: "BRB" },
        { country: "Baréin", code: "BHR" },
        { country: "Belice", code: "BLZ" },
        { country: "Benín", code: "BEN" },
        { country: "Bermudas", code: "BMU" },
        { country: "Bielorrusia", code: "BLR" },
        { country: "Birmania", code: "MMR" },
        { country: "Bolivia", code: "BOL" },
        { country: "Bosnia-Herzegovina", code: "BIH" },
        { country: "Botsuana", code: "BWA" },
        { country: "Brasil", code: "BRA" },
        { country: "Brunéi", code: "BRN" },
        { country: "Bulgaria", code: "BGR" },
        { country: "Burkina Faso", code: "BFA" },
        { country: "Burundi", code: "BDI" },
        { country: "Bután", code: "BTN" },
        { country: "Bélgica", code: "BEL" },
        { country: "Cabo Verde", code: "CPV" },
        { country: "Camboya", code: "KHM" },
        { country: "Camerún", code: "CMR" },
        { country: "Canadá", code: "CAN" },
        { country: "Caribe Neerlandés", code: "BES" },
        { country: "Catar", code: "QAT" },
        { country: "Chad", code: "TCD" },
        { country: "Chipre", code: "CYP" },
        { country: "Ciudad del Vaticano", code: "VAT" },
        { country: "Colombia", code: "COL" },
        { country: "Comoras", code: "COM" },
        { country: "Corea", code: "KOR" },
        { country: "Costa Rica", code: "CRI" },
        { country: "Costa de Marfil", code: "CIV" },
        { country: "Croacia", code: "HRV" },
        { country: "Cuba", code: "CUB" },
        { country: "Dinamarca", code: "DNK" },
        { country: "Dinastía Joseon", code: "PRK" },
        { country: "Dominica", code: "DMA" },
        { country: "Ecuador", code: "ECU" },
        { country: "Egipto", code: "EGY" },
        { country: "El Salvador", code: "SLV" },
        { country: "Emiratos Árabes Unidos", code: "ARE" },
        { country: "Eritrea", code: "ERI" },
        { country: "Eslovaquia", code: "SVK" },
        { country: "Eslovenia", code: "SVN" },
        { country: "España", code: "ESP" },
        { country: "Estados Federados de Micronesia", code: "FSM" },
        { country: "Estados Unidos", code: "USA" },
        { country: "Estonia", code: "EST" },
        { country: "Etiopía", code: "ETH" },
        { country: "Filipinas", code: "PHL" },
        { country: "Finlandia", code: "FIN" },
        { country: "Fiyi", code: "FJI" },
        { country: "Francia", code: "FRA" },
        { country: "Gabón", code: "GAB" },
        { country: "Gambia", code: "GMB" },
        { country: "Georgia", code: "GEO" },
        { country: "Ghana", code: "GHA" },
        { country: "Gibraltar", code: "GIB" },
        { country: "Granada", code: "GRD" },
        { country: "Grecia", code: "GRC" },
        { country: "Groenlandia", code: "GRL" },
        { country: "Guadalupe", code: "GLP" },
        { country: "Guam", code: "GUM" },
        { country: "Guatemala", code: "GTM" },
        { country: "Guayana Francesa", code: "GUF" },
        { country: "Guernsey", code: "GGY" },
        { country: "Guinea", code: "GIN" },
        { country: "Guinea Ecuatorial", code: "GNQ" },
        { country: "Guinea-Bisáu", code: "GNB" },
        { country: "Guyana", code: "GUY" },
        { country: "Haití", code: "HTI" },
        { country: "Honduras", code: "HND" },
        { country: "Hong Kong", code: "HKG" },
        { country: "Hungría", code: "HUN" },
        { country: "India", code: "IND" },
        { country: "Indias Orientales Neerlandesas", code: "IDN" },
        { country: "Irak", code: "IRQ" },
        { country: "Irlanda", code: "IRL" },
        { country: "Irán", code: "IRN" },
        { country: "Isla de Man", code: "IMN" },
        { country: "Islandia", code: "ISL" },
        { country: "Islas Caimán", code: "CYM" },
        { country: "Islas Cook", code: "COK" },
        { country: "Islas Feroe", code: "FRO" },
        { country: "Islas Georgias del Sur y Sandwich del Sur", code: "SGS" },
        { country: "Islas Malvinas", code: "FLK" },
        { country: "Islas Marianas del Norte", code: "MNP" },
        { country: "Islas Marshall", code: "MHL" },
        { country: "Islas Pitcairn", code: "PCN" },
        { country: "Islas Salomón", code: "SLB" },
        { country: "Islas Turcas y Caicos", code: "TCA" },
        {
          country: "Islas Ultramarinas Menores de Estados Unidos",
          code: "UMI",
        },
        { country: "Islas Vírgenes Británicas", code: "VGB" },
        { country: "Islas Vírgenes de los Estados Unidos", code: "VIR" },
        { country: "Israel", code: "ISR" },
        { country: "Italia", code: "ITA" },
        { country: "Jamaica", code: "JAM" },
        { country: "Japón", code: "JPN" },
        { country: "Jersey", code: "JEY" },
        { country: "Jordania", code: "JOR" },
        { country: "Kazajistán", code: "KAZ" },
        { country: "Kenia", code: "KEN" },
        { country: "Kirguistán", code: "KGZ" },
        { country: "Kiribati", code: "KIR" },
        { country: "Kuwait", code: "KWT" },
        { country: "Laos", code: "LAO" },
        { country: "Lesoto", code: "LSO" },
        { country: "Letonia", code: "LVA" },
        { country: "Liberia", code: "LBR" },
        { country: "Libia", code: "LBY" },
        { country: "Liechtenstein", code: "LIE" },
        { country: "Lituania", code: "LTU" },
        { country: "Luxemburgo", code: "LUX" },
        { country: "Líbano", code: "LBN" },
        { country: "Macao", code: "MAC" },
        { country: "Madagascar", code: "MDG" },
        { country: "Malasia", code: "MYS" },
        { country: "Malaui", code: "MWI" },
        { country: "Maldivas", code: "MDV" },
        { country: "Malta", code: "MLT" },
        { country: "Malí", code: "MLI" },
        { country: "Marruecos", code: "MAR" },
        { country: "Martinica", code: "MTQ" },
        { country: "Mauricio", code: "MUS" },
        { country: "Mauritania", code: "MRT" },
        { country: "Mayotte", code: "MYT" },
        { country: "Moldavia", code: "MDA" },
        { country: "Mongolia", code: "MNG" },
        { country: "Montenegro", code: "MNE" },
        { country: "Montserrat", code: "MSR" },
        { country: "Mozambique", code: "MOZ" },
        { country: "México", code: "MEX" },
        { country: "Mónaco", code: "MCO" },
        { country: "Namibia", code: "NAM" },
        { country: "Nauru", code: "NRU" },
        { country: "Nepal", code: "NPL" },
        { country: "Nicaragua", code: "NIC" },
        { country: "Nigeria", code: "NGA" },
        { country: "Niue", code: "NIU" },
        { country: "Noruega", code: "NOR" },
        { country: "Nueva Zelanda", code: "NZL" },
        { country: "Níger", code: "NER" },
        { country: "Omán", code: "OMN" },
        { country: "Pakistán", code: "PAK" },
        { country: "Palaos", code: "PLW" },
        { country: "Palestina", code: "PSE" },
        { country: "Panamá", code: "PAN" },
        { country: "Papúa Nueva Guinea", code: "PNG" },
        { country: "Paraguay", code: "PRY" },
        { country: "Países Bajos", code: "NLD" },
        { country: "Perú", code: "PER" },
        { country: "Polonia", code: "POL" },
        { country: "Portugal", code: "PRT" },
        { country: "Puerto Rico", code: "PRI" },
        { country: "Reino Unido", code: "GBR" },
        { country: "República Centroafricana", code: "CAF" },
        { country: "República Checa", code: "CZE" },
        { country: "República Democrática del Congo", code: "COD" },
        { country: "República Dominicana", code: "DOM" },
        { country: "República Popular China", code: "CHN" },
        { country: "República de China", code: "TWN" },
        { country: "República de Macedonia", code: "MKD" },
        { country: "República del Congo", code: "COG" },
        { country: "Reunión", code: "REU" },
        { country: "Ruanda", code: "RWA" },
        { country: "Rumania", code: "ROU" },
        { country: "Rusia", code: "RUS" },
        { country: "Samoa", code: "WSM" },
        { country: "Samoa Americana", code: "ASM" },
        { country: "San Cristóbal y Nieves", code: "KNA" },
        { country: "San Marino", code: "SMR" },
        { country: "San Pedro y Miquelón", code: "SPM" },
        { country: "San Vicente y las Granadinas", code: "VCT" },
        { country: "Santa Elena", code: "SHN" },
        { country: "Santa Lucía", code: "LCA" },
        { country: "Santo Tomé y Príncipe", code: "STP" },
        { country: "Senegal", code: "SEN" },
        { country: "Serbia", code: "SRB" },
        { country: "Seychelles", code: "SYC" },
        { country: "Sierra Leona", code: "SLE" },
        { country: "Singapur", code: "SGP" },
        { country: "Siria", code: "SYR" },
        { country: "Somalia", code: "SOM" },
        { country: "Sri Lanka", code: "LKA" },
        { country: "Suazilandia", code: "SWZ" },
        { country: "Sudáfrica", code: "ZAF" },
        { country: "Sudán", code: "SDN" },
        { country: "Sudán del Sur", code: "SSD" },
        { country: "Suecia", code: "SWE" },
        { country: "Suiza", code: "CHE" },
        { country: "Surinam", code: "SUR" },
        { country: "Tailandia", code: "THA" },
        { country: "Tanzania", code: "TZA" },
        { country: "Tayikistán", code: "TJK" },
        { country: "Territorio Británico del Océano Índico", code: "IOT" },
        { country: "Tierras Australes y Antárticas Francesas", code: "ATF" },
        { country: "Timor Oriental", code: "TLS" },
        { country: "Togo", code: "TGO" },
        { country: "Tokelau", code: "TKL" },
        { country: "Tonga", code: "TON" },
        { country: "Trinidad y Tobago", code: "TTO" },
        { country: "Turkmenistán", code: "TKM" },
        { country: "Turquía", code: "TUR" },
        { country: "Tuvalu", code: "TUV" },
        { country: "Túnez", code: "TUN" },
        { country: "Ucrania", code: "UKR" },
        { country: "Uganda", code: "UGA" },
        { country: "Uruguay", code: "URY" },
        { country: "Uzbekistán", code: "UZB" },
        { country: "Vanuatu", code: "VUT" },
        { country: "Venezuela", code: "VEN" },
        { country: "Vietnam", code: "VNM" },
        { country: "Wallis y Futuna", code: "WLF" },
        { country: "Yemen", code: "YEM" },
        { country: "Yibuti", code: "DJI" },
        { country: "Zambia", code: "ZMB" },
        { country: "Zimbabue", code: "ZWE" },
      ],
    };
  },
};
